// packages import
import { Box } from '@mui/material'
import { FC } from 'react'

// component import
import { ContentHead } from '../../../components/common/ContentHead'
import DepositFundForm from '../../../components/accounts/depositFund/DepositFundForm'

// others
import { CardBox } from '../../../theme/styleComponents'

const DepositFund: FC = (): JSX.Element => {
  return (
    <CardBox marginTop={3}>
      <ContentHead title="Deposit Funds" />
      <Box p={2}>
        <DepositFundForm />
      </Box>
    </CardBox>
  )
}

export default DepositFund
